import React, { useEffect } from 'react'
import { APICore } from 'helpers/api/apiCore'
import { Navigate, Route } from 'react-router-dom'
import routes from 'routes'
import useRedux from 'hooks/useRedux'
import * as loginActions from 'store/modules/login/actions'

interface PrivateRouteProps {
  children: JSX.Element
  redirectTo: string
}

const api = new APICore()

const PrivateRoute = ({ children, redirectTo }: PrivateRouteProps) => {
  const { dispatch } = useRedux()

  useEffect(() => {
    dispatch(loginActions.getStatusLeadSaga())
  }, [dispatch])

  const isAuthenticated = api.isAuthenticated()
  return isAuthenticated ? children : <Navigate to={redirectTo} />
}

function RouteGenerator() {
  const rotasPrivadas: JSX.Element[] = []

  routes.map((route, i) => {
    rotasPrivadas.push(
      <Route
        key={i}
        path={route.path}
        element={
          route.component && (
            <PrivateRoute redirectTo="/Login">
              {<>{route.component}</>}
            </PrivateRoute>
          )
        }
      >
        {route.subPaths?.map((subPath, i) => {
          return (
            <Route
              key={i}
              index={subPath.index}
              path={subPath.path && subPath.path}
              element={
                <PrivateRoute redirectTo="/Login">
                  {<>{subPath.component}</>}
                </PrivateRoute>
              }
            />
          )
        })}
      </Route>
    )
  })

  return rotasPrivadas
}

export default RouteGenerator
